import { Send } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import { api } from "@/lib/api";

export default function SupportConversation({ ticket, onTicketUpdate }) {
  const [messages, setMessages] = useState([]);
  const [body, setBody] = useState("");
  const [status, setStatus] = useState("Connecting...");
  const socketRef = useRef(null);
  const ticketId = ticket?.ticket_id;

  useEffect(() => {
    if (!ticketId) return undefined;
    api.get(`/support/tickets/${ticketId}/messages`).then((response) => setMessages(response.data));
    const socket = io(process.env.REACT_APP_BACKEND_URL, {
      path: "/api/socket.io",
      auth: { token: localStorage.getItem("afterflow_session_token") },
      transports: ["polling"],
    });
    socketRef.current = socket;
    socket.on("connect", () => {
      setStatus("Live");
      socket.emit("join_ticket", { ticket_id: ticketId });
    });
    socket.on("connect_error", () => setStatus("Reconnecting..."));
    socket.on("support:message", (message) => setMessages((items) => [...items, message]));
    socket.on("support:ticket", onTicketUpdate);
    return () => socket.disconnect();
  }, [ticketId, onTicketUpdate]);

  const send = async (event) => {
    event.preventDefault();
    if (!body.trim()) return;
    const response = await api.post(`/support/tickets/${ticket.ticket_id}/messages`, { body });
    setMessages((items) => items.some((item) => item.message_id === response.data.message_id) ? items : [...items, response.data]);
    setBody("");
  };

  if (!ticket) return null;
  return (
    <section className="panel support-conversation" data-testid="support-conversation-panel">
      <div className="panel-header"><div><h2>{ticket.subject}</h2><p>{status} · {ticket.status}</p></div></div>
      <div className="support-message-list" data-testid="support-message-list">
        {messages.map((message) => <div className="support-message" key={message.message_id} data-testid={`support-message-${message.message_id}`}><strong>{message.author_role}</strong><p>{message.body}</p></div>)}
      </div>
      <form className="support-reply-form" onSubmit={send} data-testid="support-reply-form"><input value={body} onChange={(event) => setBody(event.target.value)} placeholder="Write a reply" data-testid="support-reply-input" /><button className="primary-button" type="submit" data-testid="send-support-reply-button"><Send size={14} />Send</button></form>
    </section>
  );
}